export enum DataTypes {
  REQUEST = 'request',
  INITIAL_DATA = 'initialData',
  ROUND = 'round_create',
  HIGH_SCORES = 'high_scores_read',
  GAME_STATS = 'game_stats_read',
  WORKOUT_READ = 'workout_read',
  WORKOUT_UPDATE = 'workout_update',
  WORKOUT_CREATE = 'workout_create',
  OPEN_PAGE = 'open_page',
  ROUTE = 'route',
  PLAYCANVAS_ANALYTICS_EVENT = 'playcanvasAnalyticsEvent',
  MAKE_AVATAR = 'makeAvatar',
}

export enum DataRoutes {
  BOOTCAMP = 'bootcamp',
  GAMES = 'games',
  DASHBOARD = 'dashboard',
}
